import { render } from "./ticketReport.vue?vue&type=template&id=20221e5d&scoped=true"
import script from "./ticketReport.vue?vue&type=script&lang=js"
export * from "./ticketReport.vue?vue&type=script&lang=js"

import "./ticketReport.vue?vue&type=style&index=0&id=20221e5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20221e5d"]])

export default __exports__